import Vue from 'vue'
import app from "../../main";
import sleep from "./sleep";
import st from "../../storage";
import bus from "../BusEmisor";

var cm = "setOnlineStatus";

var wrapper = document.createElement("div");

var dialogContent = Vue.extend({
	data() {
		return {
			secounds: 20
		}
	},
	created() {
		setInterval(() => {
			this.secounds--;
		}, 1000);
	},
	template: `
    <div class="rating">
      Reconectando en {{secounds}} segundos
    </div>`
});

export default async (func, args, rs, rj) => {

	await sleep(1200);

	st.commit(cm, false);

	const execFun = () => {
		func.apply({}, Array.from(args)).then(
			r => {
				st.commit(cm, !!r);
				rs(r)
			},
			e => {
				rj(e)
			}
		)
	};

	bus.$on("connection-change", (status) => {
		if (status) {
			app.$swal.close();
			execFun();
		}
	});

	let component = new dialogContent().$mount(wrapper);

	app.$swal({
		icon: "warning",
		title: "No se pudo conectar",
		content: component.$el,
		timer: 20000,
		button: "Reconectar",
	}).then(
		() => {
			execFun()
		}
	)
}



// WEBPACK FOOTER //
// ./src/js/connection/OfflineApi.js